"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_property_decorator_1 = require("vue-property-decorator");
const vuex_1 = require("vuex");
const utils_1 = require("@/utils");
const types_1 = require("@/store/modules/vmds/types");
const modal_vue_1 = tslib_1.__importDefault(require("../modal/modal.vue"));
const FcisCalculationApi_1 = tslib_1.__importDefault(require("@/services/FcisCalculationApi"));
const utils_2 = require("@/utils");
let EmissionComponent = class EmissionComponent extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        // Component exclusive methods
        this.emissionModalIsOpen = false;
    }
    get emissionComponentData() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
        return {
            baseData: [
                {
                    label: 'Marke',
                    value: 'Mercedes-Benz',
                },
                {
                    label: 'Handelsbezeichnung',
                    value: `${this.currentVehicle.name}`,
                },
                {
                    label: 'Antriebsart',
                    value: this.engineTypeLabel,
                },
                {
                    label: 'Kraftstoffart',
                    value: this.fuelTypeDisplayLabel,
                },
                {
                    label: 'andere Energieträger',
                    value: this.fuelComplementLabel,
                },
            ],
            energyConsumption: this.energyConsumptionSummaryDetails,
            co2LabelContainer: Object.assign({ label: 'CO2-Klasse', subLabel: `Auf Grundlage der CO2-Emissionen ${!(0, utils_2.isHybridCCS)(this.engineConcept) ? '(kombiniert)' : ''}` }, this.efficiencyRating),
            furtherConsumptionData: this.furtherConsumptionData,
            costs: [
                {
                    label: `Energiekosten bei ${this.averageKmPerYear}km Jahresfahrleistung`,
                    value: `${((_a = this.vehicleCost) === null || _a === void 0 ? void 0 : _a.energyCost) || 0} €/Jahr`,
                    subvalues: this.costDetailsLabel,
                },
                {
                    label: `Mögliche CO2-Kosten über die nächsten 10 Jahre (${this.averageKmPerYear}km/Jahr)`,
                    value: null,
                    footnotes: this.costsFootnotes,
                    subvalues: [
                        {
                            label: `bei einem angenommenen mittleren durchschnittlichen CO2-Preis von ${((_d = (_c = (_b = this.vehicleCost) === null || _b === void 0 ? void 0 : _b.baseData) === null || _c === void 0 ? void 0 : _c.co2pricesPerTon) === null || _d === void 0 ? void 0 : _d.middle) || 0}€/t`,
                            value: `${((_f = (_e = this.vehicleCost) === null || _e === void 0 ? void 0 : _e.co2cost) === null || _f === void 0 ? void 0 : _f.middle) || 0} €`,
                        },
                        {
                            label: `bei einem angenommenen niedrigen durchschnittlichen CO2-Preis von ${((_j = (_h = (_g = this.vehicleCost) === null || _g === void 0 ? void 0 : _g.baseData) === null || _h === void 0 ? void 0 : _h.co2pricesPerTon) === null || _j === void 0 ? void 0 : _j.low) || 0}€/t`,
                            value: `${((_l = (_k = this.vehicleCost) === null || _k === void 0 ? void 0 : _k.co2cost) === null || _l === void 0 ? void 0 : _l.low) || 0} €`,
                        },
                        {
                            label: `bei einem angenommenen hohen durchschnittlichen CO2-Preis von ${((_p = (_o = (_m = this.vehicleCost) === null || _m === void 0 ? void 0 : _m.baseData) === null || _o === void 0 ? void 0 : _o.co2pricesPerTon) === null || _p === void 0 ? void 0 : _p.high) || 0}€/t`,
                            value: `${((_r = (_q = this.vehicleCost) === null || _q === void 0 ? void 0 : _q.co2cost) === null || _r === void 0 ? void 0 : _r.high) || 0} €`,
                        },
                    ],
                },
                {
                    label: 'Kraftfahrzeugsteuer',
                    value: ((_t = (_s = this.vehicleCost) === null || _s === void 0 ? void 0 : _s.carTax) === null || _t === void 0 ? void 0 : _t.totalTax)
                        ? `${(_v = (_u = this.vehicleCost) === null || _u === void 0 ? void 0 : _u.carTax) === null || _v === void 0 ? void 0 : _v.totalTax} €/Jahr`
                        : 'befristet steuerbefreit',
                    footnotes: (0, utils_2.isElectricCCS)(this.engineConcept) ? [3] : [],
                },
            ],
            footnotes: {
                '1': 'Es werden nur die CO2-Emissionen angegeben, die durch den Betrieb des Pkw entstehen. CO2-Emissionen, die durch die Produktion und Bereitstellung des Pkw sowie des Kraftstoffes bzw. der Energieträger entstehen oder vermieden werden, werden bei der Ermittlung der CO2-Emissionen gemäß WLTP nicht berücksichtigt.',
                '2': 'Aufgrund der CO2-Bepreisung sind künftig Erhöhungen der Kraftstoffkosten möglich. Die künftige CO2-Preisentwicklung ist unsicher, daher werden die möglichen CO2-Kosten anhand von drei angenommenen CO2-Preisen für den Zeitraum 2025 bis 2034 berechnet. Die tatsächlichen CO2-Preise können sowohl höher als auch niedriger als in den hier zugrundeliegenden Modellrechnungen ausfallen. Die CO2-Kosten sind beim Tanken mit den Kraftstoffkosten zu bezahlen. Weitere Informationen unter www.alternativ-mobil.info.',
                '3': 'Die Steuerbefreiung wird bei erstmaliger Zulassung des Elektrofahrzeugs in der Zeit vom 18.05.2011 bis 31.12.2030 für zehn Jahre ab dem Tag der erstmaligen Zulassung gewährt, längstens jedoch bis zum 31.12.2035.',
                '': 'Die Informationen erfolgen gemäß der Pkw-Energieverbrauchskennzeichnungsverordnung. Die angegebenen Werte wurden nach dem vorgeschriebenen Messverfahren WLTP (Worldwide harmonised Light-duty vehicles Test Procedures) ermittelt. Der Kraftstoffverbrauch und der CO2-Ausstoß eines Pkw sind nicht nur von der effizienten Ausnutzung des Kraftstoffs durch den Pkw, sondern auch vom Fahrstil und anderen nichttechnischen Faktoren abhängig. CO2 ist das für die Erderwärmung hauptsächlich verantwortliche Treibhausgas. Ein Leitfaden über den Kraftstoffverbrauch und die CO2-Emissionen aller in Deutschland angebotenen neuen Pkw-Modelle ist unentgeltlich in elektronischer Form einsehbar an jedem Verkaufsort in Deutschland, an dem neue Pkw ausgestellt oder angeboten werden. Der Leitfaden ist auch hier abrufbar: https://www.dat.de/co2/.',
            },
        };
    }
    // Final string data formatting for owdc-energy-consumption-labeling component
    get formattedEmissionData() {
        return JSON.stringify(this.emissionComponentData);
    }
    // CO2 Emission Section
    get energyConsumptionSummaryDetails() {
        const consumption = {
            label: `Energieverbrauch (${(0, utils_2.isHybridCCS)(this.engineConcept) ? 'gewichtet, ' : ''}kombiniert)`,
            value: this.energyConsumptionLabel,
            footnotes: (0, utils_2.isHybridCCS)(this.engineConcept) ? [1] : [],
        };
        const emission = {
            label: `CO2-Emissionen (${(0, utils_2.isHybridCCS)(this.engineConcept) ? 'gewichtet, ' : ''}kombiniert)`,
            value: this.combinedCo2emissionLabel,
            footnotes: (0, utils_2.isHybridCCS)(this.engineConcept) ? [1, 2] : [1],
        };
        const autonomy = {
            label: 'Elektrische Reichweite (EAER)',
            value: this.electricEngineRangeLabel,
            footnotes: [1],
        };
        const autonomyUrbanArea = {
            label: 'Elektrische Reichweite innerorts (EAER)',
            value: this.electricEngineRangeUrbanAreaLabel,
            footnotes: [1],
        };
        let energyConsumption = [consumption, emission];
        if ((0, utils_2.isHybridCCS)(this.engineConcept) || (0, utils_2.isElectricCCS)(this.engineConcept)) {
            if (this.electricEngineRange) {
                energyConsumption.push(autonomy);
            }
            if (this.electricEngineRangeUrbanArea) {
                energyConsumption.push(autonomyUrbanArea);
            }
        }
        return energyConsumption;
    }
    getValuePerThresholdAndEngine(threshold, engine) {
        var _a, _b, _c, _d;
        return (_d = (_c = (_b = (_a = this.currentConsumption) === null || _a === void 0 ? void 0 : _a.wltp) === null || _b === void 0 ? void 0 : _b[threshold]) === null || _c === void 0 ? void 0 : _c[engine]) === null || _d === void 0 ? void 0 : _d.individual;
    }
    get furtherConsumptionData() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const electricLabel = `Stromverbrauch ${(0, utils_2.isHybridCCS)(this.engineConcept) ? '(rein elektrischer Betrieb, kombiniert)' : 'kombiniert'}`;
        const combustionLabel = `Kraftstoffverbrauch ${(0, utils_2.isHybridCCS)(this.engineConcept) ? '(entladene Batterie, kombiniert)' : 'kombiniert'}`;
        const electricEngineLabel = (0, utils_2.isHybridCCS)(this.engineConcept) ? 'secondaryEngine' : 'primaryEngine';
        const hybridFootnotesReference = { footnotes: (0, utils_2.isHybridCCS)(this.engineConcept) ? [1] : [] };
        const electricTotal = (0, utils_2.isHybridCCS)(this.engineConcept)
            ? `${(_d = (_c = (_b = (_a = this.currentConsumption) === null || _a === void 0 ? void 0 : _a.wltp) === null || _b === void 0 ? void 0 : _b.total) === null || _c === void 0 ? void 0 : _c.secondaryEngine) === null || _d === void 0 ? void 0 : _d.individual} ${(_h = (_g = (_f = (_e = this.currentConsumption) === null || _e === void 0 ? void 0 : _e.wltp) === null || _f === void 0 ? void 0 : _f.total) === null || _g === void 0 ? void 0 : _g.secondaryEngine) === null || _h === void 0 ? void 0 : _h.unit}`
            : `${this.combinedElectricConsumption} ${this.combinedElectricConsumptionUnit}`;
        const electricData = Object.assign(Object.assign({ label: electricLabel, value: `${electricTotal}` }, hybridFootnotesReference), { subvalues: [
                {
                    label: '- Innenstadt',
                    value: `${this.getValuePerThresholdAndEngine('low', electricEngineLabel)} ${this.combinedElectricConsumptionUnit}`,
                },
                {
                    label: '- Stadtrand',
                    value: `${this.getValuePerThresholdAndEngine('medium', electricEngineLabel)} ${this.combinedElectricConsumptionUnit}`,
                },
                {
                    label: '- Landstraße',
                    value: `${this.getValuePerThresholdAndEngine('high', electricEngineLabel)} ${this.combinedElectricConsumptionUnit}`,
                },
                {
                    label: '- Autobahn',
                    value: `${this.getValuePerThresholdAndEngine('extraHigh', electricEngineLabel)} ${this.combinedElectricConsumptionUnit}`,
                },
            ] });
        const combustionData = Object.assign(Object.assign({ label: combustionLabel, value: `${this.combinedGasConsumption} ${this.combinedGasConsumptionUnit}` }, hybridFootnotesReference), { subvalues: [
                {
                    label: '- Innenstadt',
                    value: `${this.getValuePerThresholdAndEngine('low', 'primaryEngine')} ${this.combinedGasConsumptionUnit}`,
                },
                {
                    label: '- Stadtrand',
                    value: `${this.getValuePerThresholdAndEngine('medium', 'primaryEngine')} ${this.combinedGasConsumptionUnit}`,
                },
                {
                    label: '- Landstraße',
                    value: `${this.getValuePerThresholdAndEngine('high', 'primaryEngine')} ${this.combinedGasConsumptionUnit}`,
                },
                {
                    label: '- Autobahn',
                    value: `${this.getValuePerThresholdAndEngine('extraHigh', 'primaryEngine')} ${this.combinedGasConsumptionUnit}`,
                },
            ] });
        let data = [];
        if ((0, utils_2.isHybridCCS)(this.engineConcept)) {
            data.push(electricData, combustionData);
        }
        else if ((0, utils_2.isElectricCCS)(this.engineConcept)) {
            data.push(electricData);
        }
        else {
            data.push(combustionData);
        }
        return data;
    }
    // CO2 Costs Section
    get averageKmPerYear() {
        var _a, _b;
        // consider making formatting available for all markets once this is a requirement
        return Intl.NumberFormat('de').format(((_b = (_a = this.vehicleCost) === null || _a === void 0 ? void 0 : _a.baseData) === null || _b === void 0 ? void 0 : _b.averageKilometersPerYear) || 15000); // fallsback to 15000 if not available on api.
    }
    get costsFootnotes() {
        if ((0, utils_2.isHybridCCS)(this.engineConcept)) {
            return [3];
        }
        else {
            return [2];
        }
    }
    get costDetailsLabel() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const combustionDetails = {
            label: `bei Krafstoffpreis (Jahresdurchschnitt ${((_b = (_a = this.vehicleCost) === null || _a === void 0 ? void 0 : _a.baseData) === null || _b === void 0 ? void 0 : _b.energyCostBaseDate) || ''})`,
            value: `${((_e = (_d = (_c = this.vehicleCost) === null || _c === void 0 ? void 0 : _c.baseData) === null || _d === void 0 ? void 0 : _d.avgFuelPricesPer100km) === null || _e === void 0 ? void 0 : _e[this.fuelType]) || 0} €/l`,
        };
        const electricDetails = {
            label: `bei Strompreis (Jahresdurchschnitt ${((_g = (_f = this.vehicleCost) === null || _f === void 0 ? void 0 : _f.baseData) === null || _g === void 0 ? void 0 : _g.energyCostBaseDate) || ''})`,
            value: `${Math.ceil((((_k = (_j = (_h = this.vehicleCost) === null || _h === void 0 ? void 0 : _h.baseData) === null || _j === void 0 ? void 0 : _j.avgFuelPricesPer100km) === null || _k === void 0 ? void 0 : _k.ELECTRIC) || 0) * 100)} ct/kWh`,
        };
        let subvalues = [];
        if ((0, utils_2.isHybridCCS)(this.engineConcept)) {
            subvalues.push(combustionDetails, electricDetails);
        }
        else if ((0, utils_2.isElectricCCS)(this.engineConcept)) {
            subvalues.push(electricDetails);
        }
        else {
            subvalues.push(combustionDetails);
        }
        return subvalues;
    }
    // emission component v2 dynamic props
    get fuelTypeDisplayLabel() {
        switch (this.currentFuelTypes[0]) {
            case types_1.FuelType.DIESEL:
                return this.translate('diesel');
            case types_1.FuelType.PETROL:
                return this.translate('petrol');
            case types_1.FuelType.PETROL_PLUS:
                return this.translate('petrolPlus');
            case types_1.FuelType.ELECTRIC:
                return this.translate('electric');
            default:
                return 'entfällt';
        }
    }
    get isHybridOrElectric() {
        return (0, utils_2.isHybridCCS)(this.engineConcept) || (0, utils_2.isElectricCCS)(this.engineConcept);
    }
    get fuelComplementLabel() {
        return this.isHybridOrElectric ? 'Strom' : 'entfällt';
    }
    get combinedElectricConsumption() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if ((0, utils_2.isHybridCCS)(this.engineConcept)) {
            return (_d = (_c = (_b = (_a = this.currentConsumption) === null || _a === void 0 ? void 0 : _a.wltp) === null || _b === void 0 ? void 0 : _b.chargeDepleteWeighted) === null || _c === void 0 ? void 0 : _c.secondaryEngine) === null || _d === void 0 ? void 0 : _d.individual;
        }
        return (_h = (_g = (_f = (_e = this.currentConsumption) === null || _e === void 0 ? void 0 : _e.wltp) === null || _f === void 0 ? void 0 : _f.total) === null || _g === void 0 ? void 0 : _g.primaryEngine) === null || _h === void 0 ? void 0 : _h.individual;
    }
    get combinedElectricConsumptionUnit() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if ((0, utils_2.isHybridCCS)(this.engineConcept)) {
            return (_d = (_c = (_b = (_a = this.currentConsumption) === null || _a === void 0 ? void 0 : _a.wltp) === null || _b === void 0 ? void 0 : _b.chargeDepleteWeighted) === null || _c === void 0 ? void 0 : _c.secondaryEngine) === null || _d === void 0 ? void 0 : _d.unit;
        }
        return (_h = (_g = (_f = (_e = this.currentConsumption) === null || _e === void 0 ? void 0 : _e.wltp) === null || _f === void 0 ? void 0 : _f.total) === null || _g === void 0 ? void 0 : _g.primaryEngine) === null || _h === void 0 ? void 0 : _h.unit;
    }
    get energyConsumptionLabel() {
        if ((0, utils_2.isHybridCCS)(this.engineConcept)) {
            return `${this.combinedElectricConsumption} ${this.combinedElectricConsumptionUnit} + ${this.combinedGasConsumption} ${this.combinedGasConsumptionUnit}`;
        }
        return `${this.combinedGasConsumption} ${this.combinedGasConsumptionUnit}`;
    }
    get combinedElectricConsumptionLabel() {
        return `${this.combinedElectricConsumption} ${this.combinedElectricConsumptionUnit}`;
    }
    get combinedGasConsumption() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if ((0, utils_2.isHybridCCS)(this.engineConcept)) {
            return (_d = (_c = (_b = (_a = this.currentConsumption) === null || _a === void 0 ? void 0 : _a.wltp) === null || _b === void 0 ? void 0 : _b.weighted) === null || _c === void 0 ? void 0 : _c.primaryEngine) === null || _d === void 0 ? void 0 : _d.individual;
        }
        return (_h = (_g = (_f = (_e = this.currentConsumption) === null || _e === void 0 ? void 0 : _e.wltp) === null || _f === void 0 ? void 0 : _f.total) === null || _g === void 0 ? void 0 : _g.primaryEngine) === null || _h === void 0 ? void 0 : _h.individual;
    }
    get combinedGasConsumptionUnit() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if ((0, utils_2.isHybridCCS)(this.engineConcept)) {
            return (_d = (_c = (_b = (_a = this.currentConsumption) === null || _a === void 0 ? void 0 : _a.wltp) === null || _b === void 0 ? void 0 : _b.weighted) === null || _c === void 0 ? void 0 : _c.primaryEngine) === null || _d === void 0 ? void 0 : _d.unit;
        }
        return (_h = (_g = (_f = (_e = this.currentConsumption) === null || _e === void 0 ? void 0 : _e.wltp) === null || _f === void 0 ? void 0 : _f.total) === null || _g === void 0 ? void 0 : _g.primaryEngine) === null || _h === void 0 ? void 0 : _h.unit;
    }
    get combinedGasConsumptionLabel() {
        return `${this.combinedGasConsumption} ${this.combinedGasConsumptionUnit}`;
    }
    get efficiencyRating() {
        var _a, _b, _c, _d, _e, _f;
        if ((0, utils_2.isHybridCCS)(this.engineConcept)) {
            return {
                energyEfficiencyClass: (_b = (_a = this.currentEmissions) === null || _a === void 0 ? void 0 : _a.wltp) === null || _b === void 0 ? void 0 : _b.co2ClassWeighted.individual,
                energyEfficiencyClassSecondary: (_d = (_c = this.currentEmissions) === null || _c === void 0 ? void 0 : _c.wltp) === null || _d === void 0 ? void 0 : _d.co2Class.individual,
            };
        }
        else {
            return {
                energyEfficiencyClass: (_f = (_e = this.currentEmissions) === null || _e === void 0 ? void 0 : _e.wltp) === null || _f === void 0 ? void 0 : _f.co2Class.individual,
            };
        }
    }
    get combinedCo2emission() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return (((_d = (_c = (_b = (_a = this.currentEmissions) === null || _a === void 0 ? void 0 : _a.wltp) === null || _b === void 0 ? void 0 : _b.weighted) === null || _c === void 0 ? void 0 : _c.primaryEngine) === null || _d === void 0 ? void 0 : _d.individual) ||
            ((_h = (_g = (_f = (_e = this.currentEmissions) === null || _e === void 0 ? void 0 : _e.wltp) === null || _f === void 0 ? void 0 : _f.total) === null || _g === void 0 ? void 0 : _g.primaryEngine) === null || _h === void 0 ? void 0 : _h.individual));
    }
    get combinedCo2emissionLabel() {
        var _a, _b, _c, _d;
        return `${this.combinedCo2emission} ${(_d = (_c = (_b = (_a = this.currentEmissions) === null || _a === void 0 ? void 0 : _a.wltp) === null || _b === void 0 ? void 0 : _b.total) === null || _c === void 0 ? void 0 : _c.primaryEngine) === null || _d === void 0 ? void 0 : _d.unit}`;
    }
    get fuelType() {
        return (0, utils_1.getCCSFuelType)(this.currentFuelTypes[0]);
    }
    get engineConcept() {
        return (0, utils_1.getCCSEngineConcept)(this.currentEngineConcept);
    }
    get engineTypeLabel() {
        if ((0, utils_2.isHybridCCS)(this.engineConcept)) {
            return 'Plug-In-Hybrid';
        }
        else if ((0, utils_2.isElectricCCS)(this.engineConcept)) {
            return 'Elektromotor';
        }
        else {
            return 'Verbrennungsmotor';
        }
    }
    get engineCapacity() {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.currentEngine) === null || _a === void 0 ? void 0 : _a.combustionEngine) === null || _b === void 0 ? void 0 : _b.capacity) === null || _c === void 0 ? void 0 : _c.value;
    }
    get electricEngineRange() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        if ((0, utils_2.isHybridCCS)(this.engineConcept)) {
            return (_e = (_d = (_c = (_b = (_a = this.currentEngine) === null || _a === void 0 ? void 0 : _a.electricEngine) === null || _b === void 0 ? void 0 : _b.wltpRange) === null || _c === void 0 ? void 0 : _c.total) === null || _d === void 0 ? void 0 : _d.equivalentAll) === null || _e === void 0 ? void 0 : _e.individual;
        }
        return (_k = (_j = (_h = (_g = (_f = this.currentEngine) === null || _f === void 0 ? void 0 : _f.electricEngine) === null || _g === void 0 ? void 0 : _g.wltpRange) === null || _h === void 0 ? void 0 : _h.total) === null || _j === void 0 ? void 0 : _j.all) === null || _k === void 0 ? void 0 : _k.individual;
    }
    get electricEngineRangeLabel() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        if ((0, utils_2.isHybridCCS)(this.engineConcept)) {
            return `${this.electricEngineRange} ${(_e = (_d = (_c = (_b = (_a = this.currentEngine) === null || _a === void 0 ? void 0 : _a.electricEngine) === null || _b === void 0 ? void 0 : _b.wltpRange) === null || _c === void 0 ? void 0 : _c.total) === null || _d === void 0 ? void 0 : _d.equivalentAll) === null || _e === void 0 ? void 0 : _e.unit}`;
        }
        return `${this.electricEngineRange} ${(_k = (_j = (_h = (_g = (_f = this.currentEngine) === null || _f === void 0 ? void 0 : _f.electricEngine) === null || _g === void 0 ? void 0 : _g.wltpRange) === null || _h === void 0 ? void 0 : _h.total) === null || _j === void 0 ? void 0 : _j.all) === null || _k === void 0 ? void 0 : _k.unit}`;
    }
    get electricEngineRangeUrbanArea() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        if ((0, utils_2.isHybridCCS)(this.engineConcept)) {
            return (_e = (_d = (_c = (_b = (_a = this.currentEngine) === null || _a === void 0 ? void 0 : _a.electricEngine) === null || _b === void 0 ? void 0 : _b.wltpRange) === null || _c === void 0 ? void 0 : _c.lowMid) === null || _d === void 0 ? void 0 : _d.equivalentAll) === null || _e === void 0 ? void 0 : _e.individual;
        }
        return (_k = (_j = (_h = (_g = (_f = this.currentEngine) === null || _f === void 0 ? void 0 : _f.electricEngine) === null || _g === void 0 ? void 0 : _g.wltpRange) === null || _h === void 0 ? void 0 : _h.lowMid) === null || _j === void 0 ? void 0 : _j.all) === null || _k === void 0 ? void 0 : _k.individual;
    }
    get electricEngineRangeUrbanAreaLabel() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        if ((0, utils_2.isHybridCCS)(this.engineConcept)) {
            return `${this.electricEngineRangeUrbanArea} ${(_e = (_d = (_c = (_b = (_a = this.currentEngine) === null || _a === void 0 ? void 0 : _a.electricEngine) === null || _b === void 0 ? void 0 : _b.wltpRange) === null || _c === void 0 ? void 0 : _c.lowMid) === null || _d === void 0 ? void 0 : _d.equivalentAll) === null || _e === void 0 ? void 0 : _e.unit}`;
        }
        return `${this.electricEngineRangeUrbanArea} ${(_k = (_j = (_h = (_g = (_f = this.currentEngine) === null || _f === void 0 ? void 0 : _f.electricEngine) === null || _g === void 0 ? void 0 : _g.wltpRange) === null || _h === void 0 ? void 0 : _h.lowMid) === null || _j === void 0 ? void 0 : _j.all) === null || _k === void 0 ? void 0 : _k.unit}`;
    }
    toggleEmissionModal() {
        this.emissionModalIsOpen = !this.emissionModalIsOpen;
    }
    fetchData() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.vehicleCost = yield FcisCalculationApi_1.default.fetchVehicleCosts(this.combinedElectricConsumption, this.combinedGasConsumption, this.combinedCo2emission, this.engineCapacity, this.fuelType, this.engineConcept);
            const parentEl = this.$refs.owccWrapper;
            const emissionComponents = parentEl.getElementsByTagName('owcc-energy-consumption-labeling');
            Array.from(emissionComponents).forEach((element) => {
                element.setAttribute('label-data', JSON.stringify(this.emissionComponentData));
            });
        });
    }
    onPropsChange() {
        if (this.combinedGasConsumption) {
            this.fetchData();
        }
    }
    mounted() {
        this.fetchData();
    }
};
tslib_1.__decorate([
    (0, vue_property_decorator_1.Ref)('owccWrapper')
], EmissionComponent.prototype, "owccWrapper", void 0);
tslib_1.__decorate([
    (0, vue_property_decorator_1.Watch)('currentVehicle')
], EmissionComponent.prototype, "onPropsChange", null);
EmissionComponent = tslib_1.__decorate([
    (0, vue_property_decorator_1.Component)({
        name: 'EmissionComponent',
        components: { Modal: modal_vue_1.default },
        computed: Object.assign({}, (0, vuex_1.mapGetters)([
            'translate',
            'currentEngineConcept',
            'currentFuelTypes',
            'currentEmissions',
            'currentConsumption',
            'currentEngine',
            'currentVehicle',
        ])),
        methods: {
        // ...mapActions(MODULES.CAR_CONFIGURATION, ['getVehicleCosts']), ToDo: integrate with store?
        },
    })
], EmissionComponent);
exports.default = EmissionComponent;
